import { downloadFile, format, mapPaginationParamsToServer } from "@/shared";

import { mapRepairFiltersToServer } from "./mappers/mapRepairFiltersToServer";

export const exportRepairs = async (paginationParams, filters) => {
    const fileName = `exported_repairs_${format(
        new Date(),
        "dd_MM_yyyy-HH_mm"
    )}`;

    await downloadFile("/repair/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
        ...mapRepairFiltersToServer(filters),
    });
};
